module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chtitle"
  }, [_vm._v("8")]), _vm._v(" "), _c('p', {
    staticClass: "centerb"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Saturday Afternoon")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Harrie and Ginger sat for several minutes inside the amphitheater while Harrie explained all she could about the dream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger stayed quiet for several seconds after Harrie finished. Then she said, “So if you had to guess, would you say the body was that of a man or a woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie frowned as she gave that some thought. “Hmm. My gut tells me it’s a man. It’s just a feeling I have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Ginger said, “then the next question seems obvious. Why have we not heard anything at all about this? Forget about television news. The newspapers have the time and the space to report on stuff like this. I read the Albuquerque Journal each morning, and so do you. I can’t imagine why one of us wouldn’t have seen something about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie shook her head. “Beats me, but there must be a reason.” She halted and grabbed Ginger’s arm. “Something occurred to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Lay it on me,” Ginger said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I should have paid more attention to Mark when he asked me what DJ had to say about all this.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I thought you provided a logical answer. There’s no way he would discuss an ongoing Bureau case with you. Even I know that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie stood up and paced. “You’re right, but that’s not what I meant. I’m thinking if I can get information from someone else—say, for instance, our friend Detective Sergeant Cabrini Paiz, or our other close friend Lieutenant Bob Swanson ….”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger shook her head and rose from her seat. “Oh, no you don’t.” She intercepted Harrie in mid pace and grabbed her by the arm. “You know perfectly well Swannie is a direct conduit to your mother-in-law. He tells her, she tells DJ, then where are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie grinned. “I’m guessing about halfway there. Don’t you see? If I go through someone else and DJ finds out, he won’t be able to stop himself from asking me about it. Once he brings it up, we’ll have a conversation on the subject.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You know you’re nuts, don’t you?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“Probably,” Harrie said. She looked at her watch. “Come on, we need to get going.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They walked toward the parking lot. When they reached the adjoining path, Harrie said, “Shouldn’t we take a quick peek at the Visitor Center? Maybe we could pick up more information about the Monument. Perhaps it’ll give me some ideas.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” Ginger said, “but let’s make it fast. I need to get home and assess the damage to our bank account after Steve’s trip to the hobby store.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Visitor Center was almost as inviting as the amphitheater. A covered area with tables and benches greeted them just outside the entrance. People could sit and enjoy another spectacular view of the city below. Inside, rows of shelving displayed books, maps, and pamphlets about the area. It was inviting and would, Harrie realized, require another, longer visit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A gray-haired gentleman stood behind the counter. He smiled at them as they entered. “Welcome to the Petroglyphs,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie and Ginger thanked him, then stopped to look at some displays. Harrie selected a map, two books, and a video. She went to the counter to pay for them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man behind the counter sported a badge pinned to his shirt. It declared his name to be Ed. Ed smiled at Harrie and Ginger. “Are you ladies tourists?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie smiled back. “No, just almost-natives who’ve never taken the time to visit this place until now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ginger said, “We were on this side of town today and are remedying that oversight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed grinned and nodded. “Know what ya mean. Lots of folks get so busy with the day-to-day grind, they sometimes don’t get around to the interesting things. We’re just glad you’re here today.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before long, Harrie and Ginger were having a great conversation with their new friend. He talked about the site, its history, and its being established as a national monument. Harrie could tell he loved this place, and he was a fountain of information.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take this building here,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie looked around, then back at Ed. “You mean the Visitor Center?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“Yes,” Ed said. “I’ll bet you didn’t know a famous lady lived ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("here back in the day.”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie said, “She lived here in the Visitor Center?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He grinned. “Well it wasn’t a visitor center then. This was her house. They remodeled it to become the Visitor Center.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh,” Harrie said, “you had me going there for a moment. So who was this woman?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed leaned on the counter and said, “Her name was Sophie Aberle, and she lived to be 100. She went to Stanford in 1927 and got her Ph.D. and Yale in 1930 and received her M.D. During those years women rarely achieved that. She spent a lot of time working with the Pueblo Indians too. Came to visit New Mexico for a while right after Stanford. Later she moved back here and continued her work after she graduated from Yale. She was quite the lady, and then being a doctor to boot. Yes sir, Sophie was one of a kind—bright, independent, a real achiever. When she married William A. Brophy, she opted not to take his last name.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harrie said, “I imagine that choice was unusual, but I can see why she did it. Sounds like she was a real feminist.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed shook his head, “Nope, that’s not it.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Really?” Ginger said. “Then why not take Mr. Brophy’s name?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ed grinned. “Because,” he said, “she didn’t want to be known as Sophie Brophy.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2df23f17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/10_Chapter08.vue
// module id = 93
// module chunks = 0